import { DefaultState, Filters } from 'store/types';

export const SET_EXTERNAL_API_CALLS_TABLE_FILTERS = "SET_EXTERNAL_API_CALLS_TABLE_FILTERS";

export type GetExternalCallsTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetGetExternalCallsTableFilters {
  type: typeof SET_EXTERNAL_API_CALLS_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type GetExternalCallsTableFiltersActionTypes = SetGetExternalCallsTableFilters;
